import React from "react";
import InfoRow from "../InfoRow";
import { Separator } from "../ui/separator";
import { Button } from "../ui/button";
import { format } from "date-fns";
import { cn, getCustomizationValue, renderCurrency } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";

const SettlementDetailsModal = ({ settlement }) => {
	const { user } = useAuth();

	return (
		<>
			<div className="tw-flex tw-flex-col tw-gap-5">
				<Section title="Contact Details">
					<InfoRow title={cn(getCustomizationValue(user, "customer_label", true), " Name")}>
						{settlement?.first_name} {settlement?.last_name}
					</InfoRow>
					<InfoRow title="Business Name">{settlement?.business_name}</InfoRow>
					<InfoRow title={cn(getCustomizationValue(user, "customer_label", true), " ID")}>{settlement?.customer_id}</InfoRow>
				</Section>
				<Section title={cn(getCustomizationValue(user, "invoice_label", true), " Details")}>
					<Separator className="tw-my-5 tw-bg-[#33333326]" />
					<InfoRow title={cn(getCustomizationValue(user, "invoice_label", true), " number:")}>{settlement?.invoice_id}</InfoRow>
					<InfoRow title="Due date:">{format(settlement?.due_date, "PPP")}</InfoRow>
					<Separator className="tw-my-5 tw-bg-[#33333326]" />
					<InfoRow className="tw-capitalize" title="Mode of Payment:">
						{settlement?.payment_method}
					</InfoRow>
					<InfoRow className="tw-capitalize" title="Gateway:">
						{settlement?.payment_provider}
					</InfoRow>
					<Separator className="tw-my-5 tw-bg-[#33333326]" />
					<InfoRow title="Subtotal:">{renderCurrency(settlement?.amount)}</InfoRow>
					{/* <InfoRow title="Discount:">N100,000.00</InfoRow> */}
					<InfoRow title="VAT:">{renderCurrency(settlement?.vat)}</InfoRow>
					<InfoRow title="Transaction fee:">{renderCurrency(settlement?.transaction_fee)}</InfoRow>
					<InfoRow title="Total:" className="tw-font-bold tw-text-black tw-text-[16px]">
						{renderCurrency(settlement?.transaction_amount)}
					</InfoRow>
				</Section>
			</div>
			<div className="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-auto">
				<Button>Download Receipt</Button>
				<Button variant="secondary">Share Receipt</Button>
			</div>
		</>
	);
};

const Section = ({ children, title }) => {
	return (
		<div className="grid">
			<p className="tw-text-gray text-[12px] tw-font-bold tw-mb-1.5">{title}</p>
			{children}
		</div>
	);
};

export default SettlementDetailsModal;
